import React, { useEffect } from "react";
import { TrainersManagementLayout } from "./style";
import { TrainersTable } from "./components/trainersTable/TrainersTable";
import { Outlet, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store/config";
import { resetTrainers } from "../../store/features/trainers/trainers-slice";

export const Trainers = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetTrainers());
    };
  }, []);

  return (
    <TrainersManagementLayout>
      {location.pathname === "/trainers" && <TrainersTable />}
      <Outlet />
    </TrainersManagementLayout>
  );
};

export default Trainers;
